import tableHideComponent from './index.vue'

const tableHide = {
  install: function (Vue) {
    Vue.component('tableHide', tableHideComponent)
  }
}

export default tableHide


// WEBPACK FOOTER //
// ./src/components/TableHide/index.js